import * as moment from 'moment';
import queryString from 'query-string';
import React, {
    PureComponent
} from 'react';
import ReactExport from "react-export-excel";
import Loader from 'react-loader-spinner';
import { withRouter } from 'react-router-dom';
import { Button, Col, ControlLabel, Input, InputGroup, InputPicker, Panel, PanelGroup, Row } from 'rsuite';
import { palletCaseSkuStatus } from '../../../../app/appConfig';
import { formatStringForAPI, formatTrueFalseToBit, queryStringParse } from '../../../../resources/logic/functions';
import { textNumbersSymbolsInputmask } from '../../../../resources/logic/inputMasks';
import RButtonHideShowFilter from '../../../componentsGeneral/Rsuite/Button/RButtonHideShowFilter';
import RDatePickerRange from '../../../componentsGeneral/Rsuite/DatePicker/RDatePickerRange';
import RCheckPicker from '../../../componentsGeneral/Rsuite/InputPicker/RCheckPicker';
import RTableGeneral from '../../../componentsGeneral/Rsuite/Table/RTableGeneral';
import InventorySkuRefDataElements from '../../../dataComponentsInventory/InventorySkuRefDataElements';
import AddNewSkuDrawer from './AddNewSkuDrawer';
// const tableIdCol = "SkuID"

const footerStyles = {
    padding: '10px 2px',
    borderTop: '1px solid #e5e5e5'
};

//For excel export
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var currentDateTime = moment().format("_YYYY-MM-DDTHH-mm-ss")

const styles = {
    marginBottom: 15
};

const mountRef = React.createRef();

class InventoryItemMaster extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            //Warehouse & Customer Arrays
            warehouseArray: {},
            customerArray: {},

            // Table Check Box
            checkedKeys: [],

            //Search Values
            isFilterShown: true,
            SKU: '',
            ProjectID: null,
            Project: null,
            CustomerRefID: null,
            CustomerRef: null,
            // Notes: '',
            ProductName: '',
            ProductDetails: '',
            // ProductURL: '',
            ProductCountryofOrigin: '',
            HTSCode: '',
            PGAFlag: '',


            //Add New Item
            showAddNewSkuDrawer: false,

            addNewCustomerID: null,
            addNewWarehouseID: null,
            addNewSku: '',
            addNewProjectID: null,
            addNewProject: null,
            addNewCustomerRefID: null,
            addNewCustomerRef: null,
            addNewNotes: '',
            addNewProductName: '',
            addNewProductDetails: '',
            addNewProductURL: '',
            addNewProductCountryofOrigin: '',
            addNewHTSCode: '',
            addNewPGAFlag: false,

            addUPC: '',
            addPrimUomID: null,
            addPackUnitID: null,
            addPackingUomQty: null,
            addLength: null,
            addWidth: null,
            addHeight: null,
            addUomID: 1,
            addWeight: null,
            addUowID: 1,

        };

        // Table Check Box
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handleCheck = this.handleCheck.bind(this);

        // Table Sort
        this.handleSortColumn = this.handleSortColumn.bind(this);

        //Filter hide Show
        this.onClickIsFilterShown = this.onClickIsFilterShown.bind(this);
        this.onClickResetFilters = this.onClickResetFilters.bind(this);

        //Search Values
        this.onChangeState = this.onChangeState.bind(this);

        //Table buttons
        this.onClickDetails = this.onClickDetails.bind(this);

        //Add New
        this.onClickAddNew = this.onClickAddNew.bind(this);
        this.onClickConfirmAddNewItem = this.onClickConfirmAddNewItem.bind(this);
        this.closeAddNewItemDrawer = this.closeAddNewItemDrawer.bind(this);
        this.resetAddNewState = this.resetAddNewState.bind(this);

    }


    //Change State
    onChangeState(e, statename) {
        this.setState({
            [statename]: e
        });


        if (statename === 'addLength' || statename === 'addWidth' || statename === 'addHeight') {
            if (e !== '' && e !== null && this.state.addUomID === null) {
                this.setState({
                    addUomID: 1
                });
            }
        }

        if (statename === 'addWeight' ) {
            if (e !== '' && e !== null && this.state.addUowID === null) {
                this.setState({
                    addUowID: 1
                });
            }
        }

    }




    componentDidMount() {
        this.loadSortFromStorage()
        this.updateParamsFromURL()
        this.getsessionStorageData() //this will preserve menu selection
        this.loadWarehouseToState()
        this.loadCustomerToState()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.warehouseSelection !== this.props.warehouseSelection) {
            this.setState({
                checkedKeys: []
            });
        }
        if (prevProps.customerSelection !== this.props.customerSelection) {
            this.setState({
                checkedKeys: []
            });
        }

        if (prevProps.InventoryLotSkuRefPostSuccessful !== this.props.InventoryLotSkuRefPostSuccessful && this.props.InventoryLotSkuRefPostSuccessful) {
            this.closeAddNewItemDrawer()
        }

    }

    updateParamsFromURL = () => {
        const values = queryString.parse(this.props.location.search)

        try {
            this.onChangeState(queryStringParse(values.sku), 'SKU')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.project), 'Project')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.customerref), 'CustomerRef')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.productname), 'ProductName')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.productdetails), 'ProductDetails')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.productcountryoforigin), 'ProductCountryofOrigin')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.htscode), 'HTSCode')
        }
        catch (e) { }
        try {
            this.onChangeState(queryStringParse(values.pgaflag), 'PGAFlag')
        }
        catch (e) { }

    }



    //Table on click details
    onClickDetails(e, rowData, history) {
        var rowID
        rowID = 'SkuID'


        try {
            var paramID = rowData[rowID]

            if (paramID != null) {
                history.push({
                    pathname: 'itemdetails',
                    search: 'skuid=\'' + paramID + '\''
                });
            }
        }
        catch (e) {
        }

    }



    // Table Sort
    saveSortTosessionStorage(sortColumn, sortType) {
        try {
            sessionStorage.setItem('sortcolumn', sortColumn)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortType', sortType)
        }
        catch (e) { }
        try {
            sessionStorage.setItem('sortURLPathname', this.props.location.pathname)
        }
        catch (e) { }
    }
    loadSortFromStorage() {
        var sortColumn = null
        var sortType = null
        var pathName = null
        try {
            sortColumn = sessionStorage.getItem('sortcolumn')
        }
        catch (e) { }
        try {
            sortType = sessionStorage.getItem('sortType')
        }
        catch (e) { }
        try {
            pathName = sessionStorage.getItem('sortURLPathname')
        }
        catch (e) { }
        if (pathName === this.props.location.pathname) {

            this.handleSortColumn(sortColumn, sortType)
        }
    }
    handleSortColumn(sortColumn, sortType) {
        this.setState({
            loading: true
        });
        this.saveSortTosessionStorage(sortColumn, sortType)
        setTimeout(() => {
            this.setState({
                sortColumn,
                sortType,
                loading: false
            });
        }, 100);
    }


    loadWarehouseToState() {
        if (typeof (this.props.warehouseSelection) === 'number') {
            this.setState({
                addNewWarehouseID: this.props.warehouseSelection
            });
        }
    }

    loadCustomerToState() {
        if (typeof (this.props.customerSelection) === 'number') {
            this.setState({
                addNewCustomerID: this.props.customerSelection
            });
        }
    }

    getsessionStorageData() {
        try {
            let warehouseMenuList = JSON.parse(sessionStorage.getItem('AppConfig.WarehouseArray'));
            if (warehouseMenuList != null && warehouseMenuList != undefined) {
                this.setState({
                    warehouseArray: warehouseMenuList
                })
            }
        }
        catch (e) { }
        try {
            let customerMenuList = JSON.parse(sessionStorage.getItem('AppConfig.CustomerArray'));
            if (customerMenuList != null && customerMenuList != undefined) {
                this.setState({
                    customerArray: customerMenuList
                })
            }
        }
        catch (e) { }
        try {
            let carrierMenuList = JSON.parse(sessionStorage.getItem('AppConfig.CarrierArray'));
            if (carrierMenuList != null && carrierMenuList != undefined) {
                this.setState({
                    carrierArray: carrierMenuList
                })
            }
        }
        catch (e) { }
        try {
            let carrierServiceMenuList = JSON.parse(sessionStorage.getItem('AppConfig.CarrierServiceArray'));
            if (carrierServiceMenuList != null && carrierServiceMenuList != undefined) {
                this.setState({
                    carrierServiceArray: carrierServiceMenuList
                })
            }
        }
        catch (e) { }
    }






    // Table Check Box
    handleCheckAll(value, checked, data) {
        var rowID
        rowID = 'SkuID'


        const checkedKeys = checked ? [] : data.map(item => item[rowID]);
        this.setState({
            checkedKeys
        });
    }
    handleCheck(value, checked) {
        const { checkedKeys } = this.state;
        const nextCheckedKeys = checked
            ? [...checkedKeys, value]
            : checkedKeys.filter(item => item !== value);

        this.setState({
            checkedKeys: nextCheckedKeys
        });
    }

    //Filter
    onClickIsFilterShown(e, isFilterShown) {
        if (isFilterShown) {
            this.setState({
                isFilterShown: false
            });
        }
        else {
            this.setState({
                isFilterShown: true
            });
        }
    }
    onClickResetFilters(e) {
        this.setState({
            isFilterShown: false
        });
        this.setState({
            SKU: '',

            ProjectID: null,
            Project: null,
            CustomerRefID: null,
            CustomerRef: null,
            // Notes: '',

            ProductName: '',
            ProductDetails: '',
            // ProductURL: '',
            ProductCountryofOrigin: '',
            HTSCode: '',
            PGAFlag: '',

        });

        setTimeout(() => {
            this.setState({
                isFilterShown: true
            });
        }, 500);
    }

    onClickApplySearch(e) {

        try {

            this.props.history.push({
                search:
                    'sku=' + this.state.SKU + '&' +
                    'projectid=' + this.state.ProjectID + '&' +
                    'project=' + this.state.Project + '&' +
                    'customerrefid=' + this.state.CustomerRefID + '&' +
                    'customerref=' + this.state.CustomerRef + '&' +
                    'productname=' + this.state.ProductName + '&' +
                    'productdetails=' + this.state.ProductDetails + '&' +
                    'productcountryoforigin=' + this.state.ProductCountryofOrigin + '&' +
                    'htscode=' + this.state.HTSCode + '&' +
                    'pgaflag=' + this.state.PGAFlag

            });
        }
        catch (e) { }

    }


    //Add New
    onClickAddNew(e) {

        this.resetAddNewState()

        this.loadWarehouseToState()
        this.loadCustomerToState()

        this.setState({
            showAddNewSkuDrawer: true
        });

    }

    resetAddNewState() {

        this.setState({
            addNewCustomerID: null,
            addNewWarehouseID: null,
            addNewSku: '',
            addNewProjectID: null,
            addNewProject: null,
            addNewCustomerRefID: null,
            addNewCustomerRef: null,
            addNewNotes: '',
            addNewProductName: '',
            addNewProductDetails: '',
            addNewProductURL: '',
            addNewProductCountryofOrigin: '',
            addNewHTSCode: '',
            addNewPGAFlag: false,

            addUPC: '',
            addPrimUomID: null,
            addPackUnitID: null,
            addPackingUomQty: null,
            addLength: null,
            addWidth: null,
            addHeight: null,
            addUomID: 1,
            addWeight: null,
            addUowID: 1,
        });

    }


    onClickConfirmAddNewItem() {

        if (typeof (this.state.addNewWarehouseID) === 'number' && typeof (this.state.addNewCustomerID) === 'number') {
            if (this.state.addNewSku == null || this.state.addNewSku == '') {
                window.alert('Please enter SKU.')
            }
            // else if (this.state.OrderTypeID == null || this.state.OrderTypeID == '') {
            //     window.alert('Please select Order Type.')
            // }
            // else if (this.state.OrderPriorityID == null || this.state.OrderPriorityID == '') {
            //     window.alert('Please select Order Priority.')
            // }
            // else if (this.state.OrderDate == null || this.state.OrderDate == '') {
            //     window.alert('Please select Order Date.')
            // }
            else {


                //clear out UOM if values are null :

                var newUomID = null
                var newUowID = null

                if (this.state.addLength || this.state.addWidth || this.state.addHeight) {
                    // At least one of them has a value that is not '' or null
                    newUomID = this.state.addUomID
                } else {
                    // All of them are either '' or null
                    newUomID = null
                }

                if (this.state.addWeight) {
                    // At least one of them has a value that is not '' or null
                    newUowID = this.state.addUowID
                } else {
                    // All of them are either '' or null
                    newUowID = null
                }

                this.props.inventoryLotSkuRefPost(
                    this.props.currentUserEmail,
                    this.props.userSignInData.AuthToken,
                    this.state.addNewWarehouseID,
                    this.state.addNewCustomerID,
                    null,
                    formatStringForAPI(this.state.addNewSku),
                    null,
                    null,
                    formatStringForAPI(this.state.addNewProject),
                    null,
                    formatStringForAPI(this.state.addNewCustomerRef),
                    formatStringForAPI(this.state.addNewNotes),
                    formatStringForAPI(this.state.addNewProductName),
                    formatStringForAPI(this.state.addNewProductDetails),
                    formatStringForAPI(this.state.addNewProductURL),
                    formatStringForAPI(this.state.addNewProductCountryofOrigin),
                    formatStringForAPI(this.state.addNewHTSCode),
                    formatTrueFalseToBit(this.state.addNewPGAFlag),
                    null,

                    formatStringForAPI(this.state.addUPC),
                    formatStringForAPI(this.state.addPrimUomID),
                    formatStringForAPI(this.state.addPackUnitID),
                    formatStringForAPI(this.state.addPackingUomQty),
                    formatStringForAPI(this.state.addLength),
                    formatStringForAPI(this.state.addWidth),
                    formatStringForAPI(this.state.addHeight),
                    formatStringForAPI(newUomID),
                    formatStringForAPI(this.state.addWeight),
                    formatStringForAPI(newUowID)


                )
            }
        }
        else { window.alert('Please select one Warehouse and one Customer to save data.') }

    }


    closeAddNewItemDrawer(e) {

        this.setState({
            showAddNewSkuDrawer: false
        });

        this.resetAddNewState()
    }





    render() {
        const { checkedKeys, sortColumn, sortType } = this.state;

        let hideShowSearch;
        hideShowSearch = <Row style={{ marginBottom: '5px' }}>

            <Col md={24} sm={24} >

                <p>
                    {RButtonHideShowFilter(this.props.isMobile, this.state.isFilterShown, 'Filters', this.onClickIsFilterShown, this.onClickResetFilters)}
                </p>

            </Col>
        </Row>




        if (this.props.isInventoryLotSkuRefLoading) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                    <p style={{ marginTop: '20px', fontSize: '20px', color: '#3396E5' }}>Please wait...</p>
                </div>
            );
        }


        let searchDiv;
        if (this.state.isFilterShown) {
            // && !this.props.isTransConsigneeLoading) {
            searchDiv = <Row  >
                <Col md={24} sm={24} >

                    <Panel bordered style={{ marginBottom: '10px' }}>

                        <Col md={24} sm={24} >

                            {/* <Row style={{ marginBottom: '10px' }}>
                                <ControlLabel>Status</ControlLabel>
                                <RCheckPicker
                                    data={palletCaseSkuStatus}
                                    value={this.state.searchStatus}
                                    setCheckedState={this.onChangeSearchStatus}
                                />
                            </Row> */}

                            <Row>
                                <div >
                                    <ControlLabel>SKU</ControlLabel>
                                    <InputGroup style={{ marginBottom: 10 }}>
                                        <Input value={this.state.searchItem} onChange={(e) => { this.onChangeState(e, 'SKU') }} onInput={(e) => e.target.value = textNumbersSymbolsInputmask(e)} />
                                    </InputGroup>
                                </div>
                            </Row>


                        </Col>


                        <Row>

                            {/* <ButtonToolbar style={{ marginBottom: 10, textAlignLast: 'right' }}> */}
                            <Button onClick={(e) => { this.onClickApplySearch(e) }} style={{ marginRight: '10px' }}> Apply </Button>
                            <Button onClick={(e) => { this.onClickResetFilters(e) }}> Reset </Button>
                            {/* </ButtonToolbar> */}
                        </Row>


                    </Panel>
                </Col>
            </Row >
        }
        else if (!this.state.isFilterShown) {
            searchDiv = <div></div>
        }






        let SkuTable;
        let tableSkuDataDiv;
        if (this.props.isInventorySkuRefLoading) {
            SkuTable = <div></div>
            tableSkuDataDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.InventorySkuRefData) !== 'undefined' && this.props.InventorySkuRefData != null) {

            SkuTable = RTableGeneral(
                'SkuID',     //   keyColumn,
                this.props.InventorySkuRefData,     //   tableData,
                InventorySkuRefDataElements,       //   DataElements,
                this.props.isInventorySkuRefLoading,        //   loading,

                this.props.isMobile,        //   isMobile,
                this.props.history,     //   history,

                sortColumn,     //   sortColumn,
                sortType,       //   sortType,
                this.handleSortColumn,      //   handleSortColumn,
                false, //(paramPoStatusID.includes(1) || paramPoStatusID.includes(2) || paramPoStatusID == null ? true : false), // checkColEntry,
                null, //checkedKeys,       //   checkedKeys,
                null, //this.handleCheckAll,       //   handleCheckAll,
                null, //this.handleCheck,       //   handleCheck,

                false,      //   boolSelectButton,
                null,       //   onClickSelect,
                null,       //   selectButtonText,
                null,       //   selectHighlightRowKey,

                true,       //   link1bool,
                'Details',     //   link1text,
                this.onClickDetails,     //   link1onClick,

                false,       //   link2bool,
                null,       //   link2text,
                null  //   link2onClick
            )
            tableSkuDataDiv = <div>
                {(this.props.isMobile == true) ? <div></div> :
                    <div>
                        <Row>
                            <Button style={{ float: 'left', marginRight: '10px' }} onClick={(e) => { this.onClickAddNew(e) }}>Add New</Button>

                            <ExcelFile element={<Button style={{ float: 'right' }}>Export Excel</Button>} filename={'Item_' + currentDateTime}>
                                <ExcelSheet data={this.props.InventorySkuRefData} name="Item">
                                    {
                                        InventorySkuRefDataElements.map(
                                            ({ dBKey, displayName }, idx) => {
                                                return (
                                                    <ExcelColumn label={displayName} value={dBKey} />
                                                );
                                            }
                                        )
                                    }
                                </ExcelSheet>
                            </ExcelFile>
                        </Row>
                    </div>
                }
            </div>
        }
        else {
            SkuTable = <div></div>
            tableSkuDataDiv = <div></div>
        }



        let tableDiv;
        tableDiv = <div>
            {tableSkuDataDiv}
            {SkuTable}
        </div>



        return (
            <div>
                <h3>
                    Inventory Management - Item Master
                </h3>

                {hideShowSearch}
                {searchDiv}

                <PanelGroup>

                </PanelGroup>

                {tableDiv}


                <AddNewSkuDrawer {...this.props} state={this.state} onChangeState={this.onChangeState} confirm={this.onClickConfirmAddNewItem} close={this.closeAddNewItemDrawer} />


            </div>
        );

    }
}

export default withRouter(InventoryItemMaster);





